var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#EB6270"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2598 7.40962C14.8067 7.25288 14.3262 7.19065 13.8481 7.22677C13.37 7.26289 12.9043 7.39659 12.4798 7.61962C12.3278 7.70739 12.1554 7.75359 11.9798 7.75359C11.8043 7.75359 11.6319 7.70739 11.4798 7.61962C10.7168 7.22101 9.83256 7.12117 8.99984 7.33962C8.31167 7.51671 7.70171 7.91714 7.26557 8.47815C6.82943 9.03916 6.59177 9.72902 6.58984 10.4396C6.58984 13.8396 9.88984 15.8296 11.3498 16.5296C11.5625 16.6236 11.7924 16.6721 12.0248 16.6721C12.2573 16.6721 12.4872 16.6236 12.6998 16.5296C14.1398 15.9296 17.3598 14.1696 17.4298 10.3596C17.4106 9.70567 17.1927 9.07309 16.8051 8.54609C16.4174 8.01909 15.8784 7.62267 15.2598 7.40962Z",
    fill: "#EB6270"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikes);
export default __webpack_public_path__ + "static/media/likes.f1250cd7d9f8f3b833211c9268cb5822.svg";
export { ForwardRef as ReactComponent };